// src/components/OrderPageComponents/SerialNumberDisplay.js
import React from 'react';

function SerialNumberDisplay({uniqueSerialNumbers}) {
    return (
        <div className="order-page__serial-number">
            <strong>Serial Number{uniqueSerialNumbers.length > 1 ? 's' : ''}:</strong> {uniqueSerialNumbers.join(', ')}
            <p className="threed-disclaimer"><strong>Disclaimer: </strong> This 3D model is approximate and not fully
                parametric. <br/> Dimensions, proportions, and colors are placeholders. Final geometry <br/> will be
                precisely
                scaled via parametric modeling at checkout. No liability <br/> is assumed for errors or discrepancies in
                this
                preliminary view.</p>
        </div>

    );
}

export default SerialNumberDisplay;
